import React, { useEffect, useState } from 'react';
import { useDomain } from '@useDomain';
import api from '@api';
import './GotNextHomepage.css';

function GotnextHomepage() {
  const [leaders, setLeaders] = useState(null);
  const { slug, domain } = useDomain();

  useEffect(() => {
    const fetchLeaders = async () => {
      try {
        const res = await api.get('/api/stat-leaders', {
          params: slug ? { slug } : { domain },
        });
        setLeaders(res.data);
      } catch (err) {
        console.error('Error fetching stat leaders:', err);
      }
    };

    if (slug || domain) fetchLeaders();
  }, [slug, domain]);

  return (
    <div className="gotNext_container">
      <h1 className="stat_title">Top Stat Leaders</h1>

      {leaders ? (
        <div className="stat-banners-wrapper">
          {/* POINTS */}
          <div className="stat-banner stat-points">
            <div className="name-slot">
              1. {leaders.points[0]?.firstName} — {leaders.points[0]?.pts} pts
            </div>
            <div className="name-slot">
              2. {leaders.points[1]?.firstName} — {leaders.points[1]?.pts} pts
            </div>
            <div className="name-slot">
              3. {leaders.points[2]?.firstName} — {leaders.points[2]?.pts} pts
            </div>
          </div>

          {/* THREES */}
          <div className="stat-banner stat-threes">
            <div className="name-slot">
              1. {leaders.threes[0]?.firstName} — {leaders.threes[0]?.three_pm} threes
            </div>
            <div className="name-slot">
              2. {leaders.threes[1]?.firstName} — {leaders.threes[1]?.three_pm} threes
            </div>
            <div className="name-slot">
              3. {leaders.threes[2]?.firstName} — {leaders.threes[2]?.three_pm} threes
            </div>
          </div>

          {/* REBOUNDS */}
          <div className="stat-banner stat-rebounds">
            <div className="name-slot">
              1. {leaders.rebounds[0]?.firstName} — {leaders.rebounds[0]?.reb} rebounds
            </div>
            <div className="name-slot">
              2. {leaders.rebounds[1]?.firstName} — {leaders.rebounds[1]?.reb} rebounds
            </div>
            <div className="name-slot">
              3. {leaders.rebounds[2]?.firstName} — {leaders.rebounds[2]?.reb} rebounds
            </div>
          </div>

          {/* ASSISTS */}
          <div className="stat-banner stat-assists">
            <div className="name-slot">
              1. {leaders.assists[0]?.firstName} — {leaders.assists[0]?.ast} assists
            </div>
            <div className="name-slot">
              2. {leaders.assists[1]?.firstName} — {leaders.assists[1]?.ast} assists
            </div>
            <div className="name-slot">
              3. {leaders.assists[2]?.firstName} — {leaders.assists[2]?.ast} assists
            </div>
          </div>
        </div>
      ) : (
        <p>Loading stat leaders...</p>
      )}
    </div>
  );
}

export default GotnextHomepage;
